import { UserResource } from "@clerk/types";
import {
  NON_REGULAR_STUDENT_DOMAINS,
  STUDENT_EMAIL_DOMAINS,
  TEST_USER_EMAIL_REGEX_AND_ORG_NAME,
} from "constants/config";

export const emailHasAllowedDomain = (
  emailAddress: string,
  allowedDomains: { [key: string]: string }
): string | null => {
  const emailDomain = emailAddress.split("@").pop();
  if (emailDomain) {
    for (const allowedDomain in allowedDomains) {
      if (emailDomain.endsWith(allowedDomain)) {
        return allowedDomains[allowedDomain];
      }
    }
  }
  return null;
};

export const emailIsTestUser = (emailAddress: string): string | null => {
  return TEST_USER_EMAIL_REGEX_AND_ORG_NAME.regex.test(emailAddress)
    ? TEST_USER_EMAIL_REGEX_AND_ORG_NAME.orgName
    : null;
};

export const emailHasStudentDomain = (emailAddress: string): boolean => {
  const emailDomain: string | undefined = emailAddress.split("@").pop();
  if (emailDomain) {
    // Check if domain ends with any of the allow-listed student domains
    for (const studentDomain of NON_REGULAR_STUDENT_DOMAINS) {
      if (
        emailDomain === studentDomain ||
        emailDomain.endsWith("." + studentDomain)
      ) {
        return true;
      }
    }

    // Check for generic student domains (edu, ac, student)
    const emailDomainArray: string[] = emailDomain.split(".");
    let isIncluded: boolean = false;
    STUDENT_EMAIL_DOMAINS.forEach((email_domain: string) => {
      if (emailDomainArray.includes(email_domain)) {
        isIncluded = true;
      }
    });
    return isIncluded;
  }
  return false;
};

export const getUserStudentEmail = (user?: UserResource | null) => {
  if (!user) {
    return "";
  }
  const emails = user.emailAddresses
    .filter((emailAddress) => emailAddress.verification.status === "verified")
    .map((emailAddress) => emailAddress.emailAddress);

  const found = emails.find((email) => emailHasStudentDomain(email));
  return found || "";
};
